export default {
  pageTitle: 'Apply for Promotions',
  secendTitle: 'Please select the type of promotion',
  radio1: 'Flash Sale',
  radio2: 'Today\'s Deal',
  radio3: 'Cross-Store Spend & Save',
  radio4: 'Group-on',
  radio5: 'Mega Campaign',
  radio6: 'Limited-Time Deal',
  tips1: 'Please select the date and session',
  tips2: ' Please select the duration of your product',
  dayRadio1: '1 day',
  dayRadio2: '2 days',
  dayRadio3: '3 days',
  dayRadio4: '5 days',
  dayRadio5: '7 days',
  dayRadio15: '15 days',
  dayRadio30: '30 days',
  day: 'Days',
  tips3: 'If the application is approved, the price will be automatically restored to original after deadline',
  tips4: 'If the duration is selected as 1 Day, it will be displayed on the Flashsale channel at the same time',
  application: 'Group-on Application',
  tips5: 'Validity Period of group-on',
  tips6: 'Number of group-on members',
  tips7: 'Group-on failure overdue time (hours)',
  tips8: 'Expected start time',
  placeholder1: 'Select Time',
  activitylist: 'Reduction on Amount',
  statusDisplaylist1: 'To be reviewed',
  statusDisplaylist2: 'Not yet started',
  statusDisplaylist3: 'Processing',
  statusDisplaylist4: 'Expired',
  statusDisplaylist5: 'Cancel or reject',
  // --------
  bigpromotionstatus1: 'To be reviewed',
  bigpromotionstatus2: 'To be started',
  bigpromotionstatus3: 'Ongoing',
  bigpromotionstatus4: 'Expired',
  bigpromotionstatus5: 'Cancel or remove or reject',
  // --------
  columns1: 'Event ID',
  columns2: 'Event name',
  columns3: 'Creation time',
  columns4: 'Type of Promotion',
  columns5: 'Event content',
  columns6: 'Starting time',
  columns7: 'Status',
  columns8: 'Product Applied in Promotion',
  columns9: 'Products Applied Count',
  columns10: 'Select',
  columnsPromotion1: 'Campaign ID',
  columnsPromotion2: 'Campaign name',
  columnsPromotion3: 'Creation time',
  columnsPromotion4: 'CODE',
  columnsPromotion5: 'Start time',
  columnsPromotion6: 'End time',
  columnsPromotion7: 'Status',
  columnsPromotion8: 'Registered Products',
  columnsPromotion9: 'Select',
  error1: 'Please select the session',
  error2: 'Please select the Duration',
  error3: 'Please select an event',
  joinNow: 'Join Now',
  eventIntroduction: 'Campaign Introduction',
  eventRules: 'Campaign Rules',

  startSignUp: 'Start Sign-up',
  categoryTips: 'Category Limitation',

  ratingLimit: 'Rating Limit',
  discountRate: 'Discount Rate',
  productLimit: 'Product quantity limit',
  notLimit: 'Not limited',
  logisticsLimit: 'Logistics limitations',
  detail: 'Detail',
  discountTips: 'The price must be reduced by {num}% or more based on the recent historical lowest price.',
  limitTips: 'You are a currently active whitelist store and are not subject to the first three conditions.',
  promotionEvents: 'Campaigns',
  region: 'Region',
  more: 'More',
  eventTime: 'Event Time',

  ctgRuleTableLabel1: 'Partial category rules(%)',
  ctgRuleTableLabel2: 'Category',
  ctgRuleTableLabel3: 'Discount Rate%',
  ctgRuleTableLabel4: 'Rating Limit',
  ctgRuleTableLabel5: 'Logistics limitations',
  modifyProductPrice: 'Modify product price',
  signUp: 'Sign Up'
}
